import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function lr2(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@lr2/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@lr2/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@lr2/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@lr2/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@lr2/UPDATE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@lr2/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}